
import AGButton from "../../components/Button";
import Card from "../../components/Card";
import AGModal from "../Modal";
import { CompleteCreateServiceModalProps } from "./completeCreateService.props";
import {
	CommerceCompassStyled,
	ThankPage
} from "./completeCreateService.styled";

export const CompleteCreateServiceModal = ({ toggleModal, visible, submitAnother, showSubmitAnother,comOfferingType }: CompleteCreateServiceModalProps) => {
	return (
		<AGModal
			setHeight={420}
			toggleModal={() => {
				toggleModal();
			}}
			title="Thanks!"
			footer={<>
				{showSubmitAnother && (
					<AGButton
						onClick={() => { submitAnother() }}
						type="Primary">
						Submit another {comOfferingType}
					</AGButton>)}
				<AGButton
					onClick={() => {
						toggleModal(); 
					}}
					type="Secondary">
					Close
				</AGButton>
			</>}
			visible={visible}
		>
			<CommerceCompassStyled>
				<Card>
					<ThankPage className="no-print">
						<div>
							<div className="thank-you-page-container thank-you-page-message">
								<span className="text-format-content ">
									Your response was submitted.
									<br />
									<br />
									{showSubmitAnother && (<>
										Do you have another expertise to share? Please select "Submit another {comOfferingType}" down below.
										<br />
										<br />
									</>)}

									If you have any questions or corrections to your
									entry, please contact{" "}
									{process.env.REACT_APP_CONTACT_NAME ||
										"Natasha Schamberger"}{" "}
									at{" "}
									<a
										href={`mailto:${process.env.REACT_APP_CONTACT_MAIL ||
											"natasha@allinialglobal.com"
											}`}
										className="linkified">
										{process.env.REACT_APP_CONTACT_MAIL ||
											"natasha@allinialglobal.com"}
									</a>
									/
									{process.env.REACT_APP_CONTACT_PHONE || "+1470 567 4594"}.
									<br />
									<br />
									Thank you for participating and we value your
									input.
								</span>
							</div>
						</div>
					</ThankPage>
				</Card>
			</CommerceCompassStyled>
		</AGModal >
	);
};
